import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getCartItem, getOrderDetail } from "../actions/storeActions";
import bg from "../assets/about.jpg";
import Loading from "../helpers/Loading";
const Checkout = () => {
  const { id } = useParams();
  const { state } = useLocation();
  let eachProductTotalPrice = 0;
  let totalPrice = 0;
  const [cartDetails, setCartDetails] = useState(null);
  useEffect(() => {
    (async function getPlaceOrder() {
      const data = await getOrderDetail(id);

      setCartDetails(data);
    })();
  }, [id]);

  if (cartDetails === null) return <Loading />;

  return (
    <div className="checkout_container">
      <div className="detail">
        <p className="detail_header ">Order ID: {id}</p>
        {cartDetails.data.map((data) => {
          const { thumbnail, name, price, total, _id } = data;
          eachProductTotalPrice = price * total;
          totalPrice += price * total;
          return (
            <React.Fragment key={_id}>
              <div className="product_cart_details">
                <div className="product">
                  <img
                    src={
                      thumbnail
                        ? `https://drive.google.com/thumbnail?id=${thumbnail}`
                        : bg
                    }
                    alt=""
                    className="cart_thumbnail"
                  />
                  <div className="product_details">
                    <div>
                      <strong>
                        {name} X {total}
                      </strong>
                      <div className="variations">
                        {/* <strong>Variants</strong> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="quantity">
                  <h3>Price</h3>
                  <p>₱{eachProductTotalPrice}</p>
                </div>
              </div>
            </React.Fragment>
          );
        })}
        <div className="detail">
          <p className="detail_header">Total Price</p>
          <p>{totalPrice}</p>
        </div>
        <div className="detail">
          <p className="detail_header">Message</p>
          <p>{cartDetails.message}</p>
        </div>
        <div className="detail">
          <p className="detail_header">Earned</p>
          <p>
            Congratulations you just earned {cartDetails.totalPoints} points!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
